module.exports = {
    init: function () {
        /* Setup the variables for the buttons and content to show hide */
        var self = this;

        self.submit = $('#register-button');

        if ($('#js-businessOpenBtn').length !== 0) {
            // only send tracking if the locale is configured to ask if they are a business
            self.submit.on('click', function () {
                self.doTracking();
            });
        }
    },

    doTracking: function () {
        var _bootstrapper = window.Bootstrapper || {};
        var self = this;

        self.btnOpen = $('#js-accountCustomerOpenBtn');
        if(self.btnOpen.hasClass('active')) {
            self.haveAccount = 'Yes';
        }

        self.btnClose = $('#js-accountCustomerCloseBtn');
        if(self.btnClose.hasClass('active')) {
            self.haveAccount = 'No';
        }

        self.btnYes = $('#js-businessOpenBtn');
        if(self.btnYes.hasClass('active')) {
            self.business = 'Yes';
        }

        self.btnNo = $('#js-businessCloseBtn');
        if(self.btnNo.hasClass('active')) {
            self.business = 'No';
        }

        var formTracking = {
            'category': {
                'primaryCategory': 'formSubmission',
                'formSubmission': 'Success'
            },
            'attributes': {
                'formType': 'Registration',
                'haveAccount': self.haveAccount,
                'business': self.business,
                'formError': '',
                'valueStreamType': 'My Account'
            }
        };

       _bootstrapper.ensEvent.trigger('genericFormTracking', formTracking);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/tracking.js
// module id = 260
// module chunks = 4